var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.data.text)}}),_c('button',{staticClass:"ui green button",on:{"click":_vm.openLink}},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }